import * as Api from "@modules/api";
import { handleDispatchResult } from "@utils/helpers/handleDispatchResult";

import { store } from "../store";
import { contactUsAsync } from "./slices";

export const contactUs = async (
  body: Api.Server.ContactUsInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(contactUsAsync(body));

  return handleDispatchResult(res, onSuccess);
};
